import React from "react";
import { useSnackbar } from "notistack";
import "./roomControls.css";

export default function RoomControls({
  participants,
  onMuteAll,
  onKickParticipant,
}) {
  const { enqueueSnackbar } = useSnackbar();

  const handleMuteAll = () => {
    onMuteAll();
    enqueueSnackbar("All participants muted", { variant: "success" });
  };

  const handleKickParticipant = (participantId) => {
    onKickParticipant(participantId);
    enqueueSnackbar("Participant removed", { variant: "info" });
  };

  return (
    <div className="room-controls">
      <h3>Room Controls</h3>

      <div className="controls-grid">
        <div className="control-group">
          <h4>Audio Controls</h4>
          <button onClick={handleMuteAll}>Mute All</button>
          <button
            onClick={() =>
              enqueueSnackbar("Feature coming soon!", { variant: "info" })
            }
          >
            Mute Selected
          </button>
        </div>

        <div className="control-group">
          <h4>Room Management</h4>
          <button
            onClick={() =>
              enqueueSnackbar("Feature coming soon!", { variant: "info" })
            }
          >
            Lock Room
          </button>
          <button
            onClick={() =>
              enqueueSnackbar("Feature coming soon!", { variant: "info" })
            }
          >
            Set Password
          </button>
        </div>
      </div>

      <div className="participant-list">
        <h4>Participants ({participants.length})</h4>
        {participants.length > 0 ? (
          <ul>
            {participants.map((participant) => (
              <li key={participant.id} className="participant-item">
                <div className="participant-info">
                  <span
                    className={`participant-status ${
                      participant.isMuted ? "muted" : ""
                    }`}
                    title={participant.isMuted ? "Muted" : "Active"}
                  />
                  <span>
                    {participant.name ||
                      `Participant ${participant.id.slice(0, 6)}`}
                  </span>
                </div>
                <button
                  className="danger"
                  onClick={() => handleKickParticipant(participant.id)}
                >
                  Remove
                </button>
              </li>
            ))}
          </ul>
        ) : (
          <p>No other participants in the room</p>
        )}
      </div>
    </div>
  );
}
